
import { Component, Vue, Prop } from 'vue-property-decorator'
import { IAppForm } from './../IAppForm'
import { ApplicationModule, WizardModule } from '@/store'

import AddressDto from '@/types/dto/addressDto'
import LookupValueDto from '@/types/dto/lookupValueDto'
import { WizardPage_Enum } from '../../../enums/WizardPage_Enum'

    @Component({
      name: 'AddressForm'
    })
export default class AddressForm extends Vue implements IAppForm {
  // #region Props

			@Prop() wizardIndex!: number;

			// #endregion

			// #region Data

			showLookup = true;

			stepIndex = 0;
			prevStepIndex = -1;

			value = ApplicationModule.form;

			get address () {
			  return ApplicationModule.editingAddress
			}

			// #endregion

			// #region Methods

			submit () {
			  if (!this.validate()) { return }

			  this.$emit('submit', this.wizardIndex)
			}

			validateAddress () {
			  return ((this.$refs.addressDetails as unknown) as IAppForm).validate()
			}

			validateStatus () {
			  return ((this.$refs.addressStatus as unknown) as IAppForm).validate()
			}

			validateLength () {
			  return ((this.$refs.addressLength as unknown) as IAppForm).validate()
			}

			validate () {
			  const detailsValid = this.validateAddress()
			  const statusValid = this.validateStatus()
			  const lengthValid = this.validateLength()

			  if (!detailsValid || !statusValid || !lengthValid) {
			    return false
			  }

			  return true
			}

			next () {
			  switch (this.stepIndex) {
			    case 0:
			      if (!this.validateAddress()) {
			        return
			      }
			      this.prevStepIndex = JSON.parse(JSON.stringify(this.stepIndex))
			      this.stepIndex++

			      break
			    case 1:
			      if (!this.validateStatus()) {
			        return
			      }
			      this.prevStepIndex = JSON.parse(JSON.stringify(this.stepIndex))
			      this.stepIndex++

			      break
			    case 2:
			      if (!this.validateLength()) {
			        return
			      }
			      this.prevStepIndex = -1
			      this.stepIndex = 0

			      this.addAddress()
			      break
			  }
			}

			previousStep () {
			  switch (this.stepIndex) {
			    case 0:
			      this.previous()
			      break
			    default:
			      this.prevStepIndex = JSON.parse(JSON.stringify(this.stepIndex))
			      this.stepIndex--
			      break
			  }
			}

			editAddress () {
			  if (!this.validate()) {
			    return false
			  }

			  const form = ApplicationModule.form
			  form.addresses[this.editingAddressIndex] = JSON.parse(JSON.stringify(this.address))

			  ApplicationModule.updateForm(form)

			  ApplicationModule.updateAddress(
					{
					  addressLevel: form.addresses.length,
					  yearsAtAddress: 0,
					  monthsAtAddress: 0,
					  residentialStatusLookup: {
					    id: -1
					  } as LookupValueDto
					} as AddressDto
			  )
			  ApplicationModule.updateAddressIndex(-1)

			  if (WizardModule.callback) {
			    this.$emit('go-to-page', WizardPage_Enum.Summary)
			    return
			  }

			  this.$emit('submit', this.wizardIndex)
			}

			addAddress () {
			  if (!this.validate()) {
			    return false
			  }

			  const form = ApplicationModule.form
			  form.addresses.push(JSON.parse(JSON.stringify(this.address)))

			  ApplicationModule.updateForm(form)

			  ApplicationModule.updateAddress(
					{
					  addressLevel: form.addresses.length,
					  yearsAtAddress: 0,
					  monthsAtAddress: 0,
					  residentialStatusLookup: {
					    id: -1
					  } as LookupValueDto
					} as AddressDto
			  )
			  ApplicationModule.updateAddressIndex(-1)

			  if (WizardModule.callback) {
			    this.$emit('go-to-page', WizardPage_Enum.Summary)
			    return
			  }

			  if (this.addressLength < 36) {
			    this.showLookup = false
			    this.stepIndex = 0

			    Vue.nextTick()

			    setTimeout(() => {
			      this.showLookup = true
			    }, 100)
			    return
			  }

			  this.$emit('submit', this.wizardIndex)
			}

			previous () {
			  if (WizardModule.callback) {
			    ApplicationModule.updateAddressIndex(-1)
			    ApplicationModule.updateAddress(
						{
						  yearsAtAddress: 0,
						  monthsAtAddress: 0,
						  residentialStatusLookup: {
						    id: -1
						  } as LookupValueDto
						} as AddressDto
			    )

			    this.$emit('go-to-page', WizardPage_Enum.Summary)

			    return
			  }

			  this.$emit('previous')
			}

			// #endregion

			// #region Computed

			get callback () {
			  return WizardModule.callback
			}

			get showNext () {
			  return this.stepIndex < 2
			}

			get editingAddressIndex () {
			  return ApplicationModule.editingAddressIndex
			}

			get compact () {
			  // is summary page
			  return WizardModule.callback
			}

			get addressLength () {
			  let count = 0

			  this.value.addresses.forEach(e => {
			    count += e.monthsAtAddress ? Number(e.monthsAtAddress) : 0
			    count += e.yearsAtAddress ? (Number(e.yearsAtAddress) * 12) : 0
			  })

			  count += Number(this.address.yearsAtAddress) * 12
			  count += Number(this.address.monthsAtAddress)

			  return count
			}

			get lengthRemaining () {
			  const remaining = 36 - this.addressLength
			  const years = Math.floor(remaining / 12)
			  const months = remaining % 12

			  let str = ''

			  str += years === 0 ? '' : years + (years > 1 ? ' years ' : ' year ')
			  str += months === 0 ? '' : months + (months > 1 ? ' months' : ' month')

			  return str
			}

  // #endregion
}
